<div class="d-flex px-md-5 px-2 justify-content-center sc-orders">
  <div class="col-lg-11">
    <div class="dash-panel">
      <h3 class="dash-section-title">Orders</h3>
      <app-orders-templated-list [orders]="listOrders">
      </app-orders-templated-list>
    </div>
  </div>
</div>
